import { ResponseEither } from '@/models/Common/ResponseEither';
import { IRequesterError } from '@/services/RequestService/IRequester';
import { nullish } from '@/utils/yambda';
import { identity, prop } from 'ramda';

/**
 * API 응답(ResponseEither) 에서 data 를 추출하는 과정에서 중복코드가 많이 발생하는 것으로 보여서
 * 이 과정을 유틸로 분리함
 * @param promise api 요청
 * @param responseDefault 정상 응답을 다룰 함수. default = identity
 * @param errorDefault error 발생시 응답을 다룰 함수. default = nullish
 */
const extractAPIData = async function <P, E = P, R = E>(
  promise: Promise<ResponseEither<P>>,
  responseDefault: (parameter: P) => P = identity,
  errorDefault: (error: IRequesterError<E>) => R | null = nullish,
): Promise<P | R | null> {
  return (await promise).map(prop('data')).caseOf<P | R | null>({
    left: errorDefault,
    right: responseDefault,
  });
};

export default extractAPIData;
